import { render, staticRenderFns } from "./QuotaExtItem.vue?vue&type=template&id=5b1d5876&scoped=true"
import script from "./QuotaExtItem.vue?vue&type=script&lang=js"
export * from "./QuotaExtItem.vue?vue&type=script&lang=js"
import style0 from "./QuotaExtItem.vue?vue&type=style&index=0&id=5b1d5876&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1d5876",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b1d5876')) {
      api.createRecord('5b1d5876', component.options)
    } else {
      api.reload('5b1d5876', component.options)
    }
    module.hot.accept("./QuotaExtItem.vue?vue&type=template&id=5b1d5876&scoped=true", function () {
      api.rerender('5b1d5876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/dragItem/QuotaExtItem.vue"
export default component.exports